import React from 'react';
import './Cards.css';
import CardItem from './CardItem';

function Cards() {
  return (
    <div className='cards'>
      <h1>Resources</h1>
      <div className='cards__container'>
        <div className='cards__wrapper'>
          <ul className='cards__items'>
            <CardItem
              src='https://cdn.discordapp.com/attachments/863461670607912960/885007807743684688/OpRedstone.jpg'
              text='Minecraft but you can craft OP Redstone Items'
              path='/redstone'
            />
          </ul>
        </div>
      </div>
    </div>
  );
}

export default Cards;
